import React, { useState, useEffect } from "react";
import { Button, Box, Tooltip, CircularProgress } from "@mui/material";
import { Bell } from "lucide-react";
import { useNotifications } from "./NotificationContext";

const NotificationTester = () => {
  const { addNotification, isMuted } = useNotifications();
  const [isLoading, setIsLoading] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  // Track if user has interacted with the page (for audio purposes)
  useEffect(() => {
    const handleInteraction = () => {
      setHasInteracted(true);
    };

    // Add interaction listeners to unlock audio
    document.addEventListener("click", handleInteraction);
    document.addEventListener("keydown", handleInteraction);
    document.addEventListener("touchstart", handleInteraction);

    return () => {
      document.removeEventListener("click", handleInteraction);
      document.removeEventListener("keydown", handleInteraction);
      document.removeEventListener("touchstart", handleInteraction);
    };
  }, []);

  const handleTestClick = () => {
    // Visual feedback that the button was clicked
    setIsLoading(true);

    // Create a very short delay to ensure UI updates
    setTimeout(() => {
      addNotification();
      setIsLoading(false);
    }, 300);
  };

  return (
    <Tooltip
      title={
        isMuted
          ? "Test notification (sound muted)"
          : "Test notification with sound"
      }>
      {/* <Button
        variant="outlined"
        size="small"
        onClick={handleTestClick}
        disabled={isLoading}
        startIcon={
          isLoading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <Bell size={16} />
          )
        }
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          borderColor: "#5652B0",
          color: "#5652B0",
          backgroundColor: "white",
          borderRadius: "8px",
          textTransform: "none",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 500,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          "&:hover": {
            backgroundColor: "rgba(86, 82, 176, 0.05)",
            borderColor: "#4A47A3",
          },
          zIndex: 1000,
        }}>
        {isLoading ? "Sending..." : "Test Notification"}
      </Button> */}
    </Tooltip>
  );
};

export default NotificationTester;
